import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, OrgsState} from '@/types/store/states'
import {RawOrg} from '@/types/entity/RawOrg'
import Org from '@/models/Orgs/Org'
import $store from '@/store'
import {API} from '@/constants'

const store: Module<OrgsState, RootState> = {
  namespaced: true,
  state: {
    orgs: {}
  },
  getters: {
    getOrg: state => (data: RawOrg) => {
      if (state.orgs[data.id]) {
        state.orgs[data.id].setData(data)
      } else {
        Vue.set(state.orgs, data.id, new Org(data))
      }
      return state.orgs[data.id]
    },
    getOrgs: (state, getters) => (orgsData: RawOrg[], returnArray: boolean = true) => {
      const result = returnArray ? [] : {};
      for (const orgData of orgsData) {
        const org = getters.getOrg(orgData);
        if (returnArray) {
          (result as Org[]).push(org);
        } else {
          (result as { [userId: string]: Org })[org.getId()] = org;
        }
      }
      return result;
    },
    getTree: state => (orgsList: Org[]) => {
      let map: Dictionary<Org> = {};
      for (let org of orgsList) {
        map[org.getId()] = org;
      }

      for (let org of orgsList) {
        let parent = map[org.getParentId()]
        if (parent) {
          parent.addChildren(org);
        }
      }
      let tree: Org[] = [];
      for (let org of orgsList) {
        if (!map[org.getParentId()]) {
          tree.push(org);
        }
      }
      return tree;
    },
    getRawTree: state => (orgsList: RawOrg[]) => {
      let map: Dictionary<RawOrg> = {};
      for (let org of orgsList) {
        map[org.id] = org;
      }

      for (let org of orgsList) {
        let parent = map[org.parent_id]
        if (parent) {
          if (!parent.children) {
            parent.children = []
          }
          // @ts-ignore
          parent.children.push(org);
        }
      }
      let tree: RawOrg[] = [];
      for (let org of orgsList) {
        if (!map[org.parent_id]) {
          tree.push(org);
        }
      }
      return tree;
    }
  },
  mutations: {
  },
  actions: {
    async createOrg (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.orgs.orgCreate,
        data
      }, {root: true})
      return response
    },
    async loadOrg (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.orgs.getOrg,
        data: {org_id: id}
      }, {root: true})
      console.log('LOG: loadList -> response', response)
      if (response) {
        return context.getters.getOrg(response);
      } else {
        throw new Error(`Unknow org ${response}`)
      }
    },
    async updateOrg (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.orgs.orgUpdate,
        data
      }, {root: true})
      console.log('LOG: updateOrgt -> response', response)
      return response;
    },
    async loadList (context) {
      const response = await context.dispatch('apiRequest', {
        method: API.orgs.orgList,
      }, {root: true})
      console.log('LOG: loadList -> response', response)
      return context.getters.getOrgs(response.orgs)
    },
    async byParent (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.orgs.byParent,
        data: {parent_id: id}
      }, {root: true})
      return response.orgs;
    },
    async removeOrg (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.orgs.orgRemove,
        data: {org_id: id}
      }, {root: true})
      console.log('LOG: removeOrg -> response', response)
      return response;
    },
    async setParent (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.orgs.setParent,
        data
      }, {root: true})
      console.log('LOG: setParent -> response', response)
      return response;
    },
    async loadRawOrgList (context, id) {
      // DEPRECATED
      const response = await context.dispatch('apiRequest', {
        method: API.orgs.orgList,
      }, {root: true})
      return response.orgs
    }
  }
}

export default store
